// extracted by mini-css-extract-plugin
module.exports = {"player_icon":"_7a3fb80146--player_icon--rrOgb"};